import { NgModule } from '@angular/core';
import { MqttModule } from 'ngx-mqtt';

// Minimal configuration required by ngx-mqtt
// The actual AWS IoT connection is configured dynamically in mqtt-connector.service.ts
// when connect() is called with the authentication token
const MQTT_SERVICE_OPTIONS = {
  connectOnCreate: false,
  hostname: 'placeholder',
  port: 9883,
  protocol: 'ws' as const
};

@NgModule({
  imports: [
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS)
  ]
})

export class MqttConnectorModule { }
